import { config } from "./config";
import axios from "axios";
import utils from "../utils";

let profileApi = {};

profileApi.getProfile = () => {
  return axios.get(`${config.url}/me`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

profileApi.updateProfile = (data) => {
  let dataToSend={};
  data.forEach((dataOb) => {
    dataToSend[dataOb.key]=dataOb.value
  });

  return axios.post(`${config.url}/me/update`, dataToSend, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

profileApi.getNotificationSettings = (data) => {
  return axios.get(`${config.url}/notification/settings`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

profileApi.updateNotificationSettings = (data) => {
  let dataToSend={};
  data.forEach((dataOb) => {
  dataToSend[dataOb.key]= dataOb.value;
  });

  return axios.post(`${config.url}/notification/settings`, dataToSend, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

profileApi.getNotifications = (data) => {
  return axios.post(`${config.url}/notification/list`,{}, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

profileApi.updateRole = (role,team_id) => {
  console.log(role,team_id)
  return axios.post(`${config.url}/me/role`,{
    team_id,
    role
  }, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};


export default profileApi;
